var map = {
	"./alb.svg": 34,
	"./apig.svg": 35,
	"./ddb.svg": 36,
	"./eventbridge.png": 37,
	"./icon-check.svg": 38,
	"./kinesis.svg": 39,
	"./logo.svg": 40,
	"./s3.svg": 41,
	"./sns.svg": 42,
	"./sqs.svg": 43
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33;